import { createSlice } from "@reduxjs/toolkit";

interface UserInitialStateModel {
  filter:any;
}
const userInitialState: UserInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    IncludeProperties:["StorePortfolioUser","StorePortfolioUser.Store"]

  }
};

const userManagementSlice = createSlice({
  name: "UserSlice ",
  initialState: userInitialState,
  reducers: {
    handleSetUserManagementFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetUserManagementFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc",
        IncludeProperties:["StorePortfolioUser","StorePortfolioUser.Store"]

      };
    },
   
   
    
  },
});

export const {
  handleSetUserManagementFilter,
  handleResetUserManagementFitler,
} = userManagementSlice.actions;
export default userManagementSlice;
